// ============================================================
// Shared phone validation - loose AU-friendly check.
//
// Accepts any input that contains ≥ 8 digits after stripping
// spaces, hyphens, parentheses, and the leading +. This covers
// every legitimate Australian format:
//   "0412 345 678"         → 10 digits → ok
//   "+61 412 345 678"      → 11 digits → ok
//   "(08) 8123 4567"       → 10 digits → ok
//   "08 8123 4567"         → 10 digits → ok
//   "0412345678"           → 10 digits → ok
//
// Rejects:
//   ""                     → empty → fail
//   "n/a", "later"         → 0 digits → fail
//   "123"                  → 3 digits → fail
// ============================================================

export function isValidPhone(value) {
  if (!value || typeof value !== 'string') return false;
  const digits = value.replace(/\D/g, '');
  return digits.length >= 8;
}

export const PHONE_ERROR_MESSAGE = 'Please enter a valid phone number (e.g. 0412 345 678).';
